import { render, staticRenderFns } from "./ParlayFree.vue?vue&type=template&id=24a614d9&scoped=true&"
import script from "./ParlayFree.vue?vue&type=script&lang=js&"
export * from "./ParlayFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a614d9",
  null
  
)

export default component.exports